import * as React from "react";
import { useParams } from "react-router-dom";

import { Loading } from "../../../../../../../react-components/lu-component/src";
import { adCopyV3Endpoint } from "../../../../../../../server/router/ad-copy/endpoint";
import type { GetAdCopyOAReportResponse } from "../../../../../../../server/types/request/ad-copy/report/openAnswer";
import { AdCopyRetestMenu } from "../../../../../components/pages/ad-copy/report/common";
import { AdCopyOAReportPage } from "../../../../../components/pages/ad-copy/report/oa-report";
import { ConfirmBox } from "../../../../../components/parts/confirm-box";
import { get, makeError } from "../../../../../lib/request";
import { initState, reducer } from "../../../../../reducers/ad-copy/report/oa";

export const AdCopyOAReportContainer = () => {
	const [state, dispatch] = React.useReducer(reducer, initState);

	const { data, info, job, loading } = state;

	const { activityId, jobId } = useParams<{
		activityId: string;
		jobId: string;
	}>();

	React.useEffect(() => {
		get<GetAdCopyOAReportResponse>(`${adCopyV3Endpoint.oaReport}/${jobId}`)
			.then((response) => {
				dispatch({
					payload: response.data,
					type: "loadData",
				});
			})
			.catch((error) => {
				dispatch({
					payload: makeError(error),
					type: "changeMessageInfo",
				});
			});
	}, [jobId]);

	return (
		<>
			<Loading loading={loading} />

			{job && job.retestJobId && activityId && (
				<AdCopyRetestMenu activityId={activityId} jobId={job.retestJobId.toString()} page="oa" />
			)}

			<ConfirmBox info={info} />

			{job && !!data.oaColumns && <AdCopyOAReportPage data={data} job={job} />}
		</>
	);
};
